// types
import {CouponActionTypes, CouponType, CouponState} from "./types";

export const INIT_STATE_COUPON: CouponState = {
    selectedItem: null,
    isSending: false,
    isFetched: false,
    isLoading: false,
    isNeedReload: false,
};

/**
 * The checked coupon with its discount. m9s-sales sends the discount next to
 * the coupon (`{items: [coupon], discount}`) since its v2.0.43 response DTOs;
 * the checkout reads it from the coupon, so without this a valid coupon was
 * neither shown nor sent with the order.
 */
export const couponWithDiscount = (data: any): CouponType | undefined => {
    const item: CouponType | undefined = (data?.items || [])[0];
    if (!item) {
        return undefined;
    }

    return {...item, discount: item.discount ?? data?.discount ?? undefined};
};

const Coupon = (state = INIT_STATE_COUPON, action: any) => {
    switch (action.type) {
        case CouponActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case CouponActionTypes.CHECK_M9S_COUPON:
                    return {
                        ...state,
                        selectedItem: couponWithDiscount(action.payload.data),
                        isSending: false
                    };
                default:
                    return { ...state };
            }

        case CouponActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case CouponActionTypes.CHECK_M9S_COUPON:
                    return {
                        ...state,
                        isSending: false
                    };

                default:
                    return { ...state };
            }
        case CouponActionTypes.CHECK_M9S_COUPON:
            return {
                ...state,
                selectedItem: action.payload.data,
                isSending: true
            }
        case CouponActionTypes.CLEAR_M9S_COUPON:
            return {
                ...state,
                selectedItem: null,
                isSending: false
            }
        default:
            return { ...state };
    }
};

export default Coupon;
